<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, contentAttributes } = useMessageContext();

const iframes = computed(() => {
  return contentAttributes.value.items || [];
});
</script>

<template>
  <BaseBubble class="p-3" data-bubble-name="iframe">
    <div v-if="content" class="mb-3 text-sm">{{ content }}</div>
    <div class="space-y-3">
      <div
        v-for="(iframe, index) in iframes"
        :key="index"
        class="border border-n-slate-6 rounded-lg overflow-hidden bg-n-slate-2"
      >
        <div
          v-if="iframe.title"
          class="px-3 py-2 bg-n-slate-3 border-b border-n-slate-6"
        >
          <h3 class="font-semibold text-sm text-n-slate-12">
            {{ iframe.title }}
          </h3>
        </div>
        <div class="relative" style="padding-bottom: 56.25%">
          <iframe
            v-if="iframe.src"
            :src="iframe.src"
            :title="iframe.title || 'Embedded content'"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            class="absolute top-0 left-0 w-full h-full"
          />
        </div>
        <div
          v-if="iframe.description"
          class="px-3 py-2 text-sm text-n-slate-11"
        >
          {{ iframe.description }}
        </div>
      </div>
    </div>
  </BaseBubble>
</template>
